import { forwardRef } from 'react';
import { generateInputFieldBase } from '../InputField/InputField.shell';
export const TextArea = forwardRef((props, ref) => generateInputFieldBase('chameleon-text-area', props, ref));
